import React, { useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Loader, Error, PrivateRoute, PublicRoute, EffectContext } from 'commons-ui';

import { PAGE_NAMES } from 'constant';
// import Settings from 'pages/settings';
import settingsV2 from 'commons-ui/src/pages/settingsV2';
import Login from 'pages/login/Login';
import Home from 'pages/home';
import UserProfile from 'pages/userProfile';
import BulkActions from 'pages/bulkActions';
import Miscellaneous from 'pages/miscellaneous';
// import AuthorizedRoute from 'permission/AuthorizedRoute';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';

const Routes: React.FC<{}> = () => {
	const { loader } = useContext(EffectContext);
	if (loader) {
		return <Loader />;
	}

	return (
		<Switch>
			<PublicRoute exact path='/' component={Login} />
			<PublicRoute path='/login' exact component={Login} />
			<PrivateRoute path='/home' component={Home} />
			<AuthorizedRouteV2 configPageName={PAGE_NAMES.userProfile} path='/userProfile' component={UserProfile} />
			{/* <AuthorizedRoute
				configPageName={PAGE_NAMES.settings}
				path='/settings'
				component={Settings}
				requiredPermissionLevel={PERMISSION_LEVEL.READ}
			/> */}
			<AuthorizedRouteV2 configPageName={PAGE_NAMES.settingsV2} path='/settingsV2' component={settingsV2} />
			<AuthorizedRouteV2 configPageName={PAGE_NAMES.bulkActions} path='/bulkActions' component={BulkActions} />
			<AuthorizedRouteV2 configPageName={PAGE_NAMES.miscellaneous} path='/miscellaneous' component={Miscellaneous} />

			<Route path='/error' component={Error} />
			<Redirect
				to={{
					pathname: '/error',
					state: { statusCode: 404, errorMsg: 'Page not found' }
				}}
			/>
		</Switch>
	);
};

export default Routes;
